var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "307.000000pt",
    height: "203.000000pt",
    viewBox: "0 0 307.000000 203.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,203.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1015 l0 -1015 1535 0 1535 0 0 1015 0 1015 -1535 0 -1535 0 0 -1015z m2559 399 c101 -51 151 -162 151 -334 0 -226 -98 -360 -262 -360 -73 0 -122 16 -163 52 l-35 30 0 -186 0 -186 -95 0 -95 0 0 500 0 500 79 0 78 0 13 -46 13 -45 36 35 c72 70 187 86 280 40z m-1886 -159 c32 -93 66 -201 77 -240 l18 -70 11 45 c7 25 42 134 78 243 l65 197 104 0 c57 0 104 -2 104 -4 0 -10 -303 -805 -321 -842 -11 -24 -41 -62 -66 -83 -60 -54 -121 -73 -219 -69 l-79 3 -3 79 -3 79 49 -6 c63 -7 121 18 150 65 43 70 43 69 -98 423 -73 182 -135 336 -137 343 -4 10 18 12 103 10 l109 -3 58 -170z m737 163 c1 -7 1 -93 1 -191 1 -304 17 -352 118 -350 69 1 106 29 126 95 11 39 15 102 15 255 l0 204 98 -3 97 -3 3 -347 2 -348 -78 0 -78 0 -12 44 -11 44 -35 -33 c-44 -41 -113 -65 -189 -65 -81 0 -134 18 -178 60 -61 58 -69 103 -69 397 l0 253 95 0 c69 0 95 -3 95 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2307 1260 c-44 -35 -64 -138 -47 -244 16 -104 47 -136 130 -136 80 0 120 67 120 201 0 96 -14 142 -51 173 -39 33 -113 36 -152 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYupIcon);
export default __webpack_public_path__ + "static/media/yupIcon.9357c2a0e72834d505737ff1146cf4f5.svg";
export { ForwardRef as ReactComponent };